import getTheme from './getTheme';

export { getTheme };
